import * as React from 'react';
import { Outlet, useLocation } from 'react-router-dom';

import Header from '../../components/Headers/Header';
import Sidebar from '../../components/Sidebar/Sidebar';
import classes from './DashboardLayout.module.css';
import PageTitle from '../../components/UI/PageTitle/PageTitle';
import { useTranslation } from '../../hooks/useTranslations';

// Other pages render their title beside their existing page actions.
const PAGE_TITLES: Record<string, string> = {
  '/web': 'schedule',
  '/web/schedule': 'schedule',
  '/web/chat': 'sidebar.chat',
  '/web/reports': 'reports',
  '/web/calendar': 'calendar',
  '/web/support': 'support',
  '/web/diagnostics/home-test': 'home.test',
  '/web/diagnostics/check-in': 'customer.check.in',
  '/web/settings': 'sidebar.settings',
  '/web/sales': 'sidebar.sales',
  '/web/upcoming': 'appointment.details',
  '/web/prepare-consultation': 'prepare.consultation',
};

const DashboardLayout: React.FC = () => {
  const [expandSidebar, setExpandSidebar] = React.useState(false);
  const { pathname } = useLocation();
  const { translations } = useTranslation();
  const title = PAGE_TITLES[pathname.replace(/\/$/, '')];
  return (
    <div className={classes.container}>
      <div className={classes.bodyContainer}>
        <Sidebar
          isExtended={expandSidebar}
          setIsExtended={() => setExpandSidebar(!expandSidebar)}
        />
        <div className={classes.pageContainer}>
          <Header
            loggedIn={true}
            expandedSidebar={expandSidebar}
            setShowSidebar={() => setExpandSidebar(!expandSidebar)}
          />
          <div className={classes.pageContent}>
            {title ? (
              <div className={classes.titledPage}>
                <PageTitle className={classes.pageTitle}>{translations(title)}</PageTitle>
                <div className={classes.titledPageContent}>
                  <Outlet />
                </div>
              </div>
            ) : (
              <Outlet />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default DashboardLayout;
